import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-3" }
const _hoisted_2 = {
  id: "preview-elements-block",
  class: "overflow-auto"
}
const _hoisted_3 = {
  key: 0,
  class: "pc-view"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "navbar-brand" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "collapse navbar-collapse justify-content-end" }
const _hoisted_8 = { class: "py-2 py-lg-0" }
const _hoisted_9 = { class: "navbar-nav" }
const _hoisted_10 = { class: "container-fruid content mt-0" }
const _hoisted_11 = { class: "shool-top bg-white" }
const _hoisted_12 = { id: "page_body_preview" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 1,
  class: "pc-view"
}
const _hoisted_15 = {
  key: 2,
  class: "sp-view"
}

import { ref, computed, watch, onMounted, onUnmounted } from 'vue'

interface MenuDataSet {
  kbn: string
  view_name: string
  visibility: string
  name: string
  link: string
}

// Helper function to get element value safely

export default /*@__PURE__*/_defineComponent({
  __name: 'SchoolDesignPreview',
  setup(__props) {

const getElementValue = (selector: string): string => {
  const el = document.querySelector(selector) as HTMLInputElement
  return el?.value || ''
}

// Helper function to get element dataset url safely
const getElementDataUrl = (selector: string): string => {
  const el = document.querySelector(selector) as HTMLElement
  return el?.dataset?.url || ''
}

// Reactive state
const pageBodyPreview = ref((window as any).page_preview || '')
const previewMode = ref('realtime-view')
const logo = ref(getElementDataUrl('#logo'))
const pageLogo = ref(getElementDataUrl('#page_logo'))
const navbarBgColor = ref(getElementValue('#school_design_general_page_nav_color'))
const navTextColor = ref(getElementValue('#school_design_general_page_nav_text_color'))
const pageTitle = ref(getElementValue('#school_design_main_page_title'))
const pageDescription = ref(getElementValue('#school_design_main_page_description'))
const pageTextColor = ref(getElementValue('#school_design_main_page_text_color'))
const featureTitle = ref(getElementValue('#school_design_main_page_feature_title'))
const feature1Title = ref(getElementValue('#school_design_main_page_feature_1_title'))
const feature1Description = ref(getElementValue('#school_design_main_page_feature_1_description'))
const feature1ImageUrl = ref(getElementDataUrl('#feature_1_image'))
const feature2Title = ref(getElementValue('#school_design_main_page_feature_2_title'))
const feature2Description = ref(getElementValue('#school_design_main_page_feature_2_description'))
const feature2ImageUrl = ref(getElementDataUrl('#feature_2_image'))
const feature3Title = ref(getElementValue('#school_design_main_page_feature_3_title'))
const feature3Description = ref(getElementValue('#school_design_main_page_feature_3_description'))
const feature3ImageUrl = ref(getElementDataUrl('#feature_3_image'))

const menuData = ref<MenuDataSet[]>([])

// Computed
const visibilitymMenuData = computed(() => {
  return menuData.value.filter(item => item.visibility === 'true')
})

// Methods
const changeValue = (type: string, event: Event) => {
  const value = (event.target as HTMLInputElement).value
  if (type === 'navbarBgColor') navbarBgColor.value = value
  if (type === 'navTextColor') navTextColor.value = value
  if (type === 'pageTextColor') pageTextColor.value = value
  if (type === 'pageTitle') pageTitle.value = value
  if (type === 'pageDescription') pageDescription.value = value
  if (type === 'featureTitle') featureTitle.value = value
  if (type === 'feature1Title') feature1Title.value = value
  if (type === 'feature1Description') feature1Description.value = value
  if (type === 'feature2Title') feature2Title.value = value
  if (type === 'feature2Description') feature2Description.value = value
  if (type === 'feature3Title') feature3Title.value = value
  if (type === 'feature3Description') feature3Description.value = value
}

const changeImage = (type: string, event: Event) => {
  const target = event.target as HTMLInputElement
  if (!target.files || !target.files[0]) {
    return
  }
  const reader = new FileReader()
  reader.readAsDataURL(target.files[0])
  reader.onload = (e) => {
    const result = e.target?.result as string
    if (type === 'feature1ImageUrl') feature1ImageUrl.value = result
    if (type === 'feature2ImageUrl') feature2ImageUrl.value = result
    if (type === 'feature3ImageUrl') feature3ImageUrl.value = result
    if (type === 'pageLogo') pageLogo.value = result
    if (type === 'logo') logo.value = result
  }
}

let menuUpdateTimer: ReturnType<typeof setTimeout> | null = null

const updateMenuData = () => {
  menuData.value = (window as any).menu_data || []
  menuUpdateTimer = setTimeout(() => {
    updateMenuData()
  }, 300)
}

// Watch
watch(previewMode, () => {
  if (previewMode.value === 'realtime-view') {
    pageBodyPreview.value = (window as any).page_preview
  }
})

// Event listener handlers with bound types
const eventListeners: Array<{ element: Element | null; event: string; handler: (e: Event) => void }> = []

const addEventListenerSafe = (selector: string, event: string, handler: (e: Event) => void) => {
  const element = document.querySelector(selector)
  if (element) {
    element.addEventListener(event, handler)
    eventListeners.push({ element, event, handler })
  }
}

// Lifecycle
onMounted(() => {
  addEventListenerSafe('input[name="school_design[logo]"]', 'change', (e) => changeImage('logo', e))
  addEventListenerSafe('#school_design_general_page_nav_color', 'change', (e) => changeValue('navbarBgColor', e))
  addEventListenerSafe('#school_design_general_page_nav_text_color', 'change', (e) => changeValue('navTextColor', e))
  addEventListenerSafe('#school_design_main_page_text_color', 'change', (e) => changeValue('pageTextColor', e))
  addEventListenerSafe('#school_design_main_page_page_logo', 'change', (e) => changeImage('pageLogo', e))

  addEventListenerSafe('#school_design_main_page_title', 'keyup', (e) => changeValue('pageTitle', e))
  addEventListenerSafe('#school_design_main_page_description', 'keyup', (e) => changeValue('pageDescription', e))

  addEventListenerSafe('#school_design_main_page_feature_title', 'keyup', (e) => changeValue('featureTitle', e))
  addEventListenerSafe('#school_design_main_page_feature_1_title', 'keyup', (e) => changeValue('feature1Title', e))
  addEventListenerSafe('#school_design_main_page_feature_1_description', 'keyup', (e) => changeValue('feature1Description', e))
  addEventListenerSafe('#school_design_main_page_feature_1_image', 'change', (e) => changeImage('feature1ImageUrl', e))
  addEventListenerSafe('#school_design_main_page_feature_2_title', 'keyup', (e) => changeValue('feature2Title', e))
  addEventListenerSafe('#school_design_main_page_feature_2_description', 'keyup', (e) => changeValue('feature2Description', e))
  addEventListenerSafe('#school_design_main_page_feature_2_image', 'change', (e) => changeImage('feature2ImageUrl', e))
  addEventListenerSafe('#school_design_main_page_feature_3_title', 'keyup', (e) => changeValue('feature3Title', e))
  addEventListenerSafe('#school_design_main_page_feature_3_description', 'keyup', (e) => changeValue('feature3Description', e))
  addEventListenerSafe('#school_design_main_page_feature_3_image', 'change', (e) => changeImage('feature3ImageUrl', e))

  updateMenuData()
})

onUnmounted(() => {
  // Clean up event listeners
  eventListeners.forEach(({ element, event, handler }) => {
    element?.removeEventListener(event, handler)
  })
  // Clear timer
  if (menuUpdateTimer) {
    clearTimeout(menuUpdateTimer)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (previewMode.value='realtime-view')),
        class: "btn",
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: "リアルタイムプレビュー"
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "fas fa-eye" }, null, -1 /* CACHED */)
      ]))]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (previewMode.value='pc-view')),
        class: "btn",
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: "PCプレビュー"
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("i", { class: "fas fa-desktop" }, null, -1 /* CACHED */)
      ]))]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (previewMode.value='sp-view')),
        class: "btn",
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: "モバイルプレビュー"
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1 /* CACHED */)
      ]))]),
      _cache[6] || (_cache[6] = _createElementVNode("a", {
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: "ブラウザで開く",
        href: "/",
        target: "_blank",
        class: "btn"
      }, [
        _createElementVNode("i", { class: "fas fa-external-link-alt" })
      ], -1 /* CACHED */))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (previewMode.value === 'realtime-view')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("nav", {
              style: _normalizeStyle(`background-color: ${navbarBgColor.value}`),
              class: "navbar navbar-expand-lg navbar-dark bgr-nav scrolled"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", _hoisted_5, [
                  _createElementVNode("img", {
                    src: logo.value,
                    class: "img-fluid"
                  }, null, 8 /* PROPS */, _hoisted_6)
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("button", {
                  class: "navbar-toggler",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": ".navbar-collapse",
                  "aria-expanded": "false",
                  "aria-label": "Toggle navigation"
                }, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("ul", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibilitymMenuData.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "nav-item dropdown",
                          key: item.name
                        }, [
                          _createElementVNode("a", {
                            style: _normalizeStyle(`color: ${navTextColor.value}`),
                            class: "nav-link"
                          }, _toDisplayString(item.view_name), 5 /* TEXT, STYLE */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ], 4 /* STYLE */),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", { innerHTML: pageBodyPreview.value }, null, 8 /* PROPS */, _hoisted_13)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (previewMode.value === 'pc-view')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("iframe", { src: "/" }, null, -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (previewMode.value === 'sp-view')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("iframe", { src: "/" }, null, -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})